import { render, staticRenderFns } from "./PublishSetting.vue?vue&type=template&id=30a7b410&scoped=true&"
import script from "./PublishSetting.vue?vue&type=script&lang=js&"
export * from "./PublishSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7b410",
  null
  
)

export default component.exports